import { useState } from 'react'
import './Donate1Newsletter.css'
import { sendNewsletterSignup } from '../../../services/pangolinoApi'

export function Donate1Newsletter(): JSX.Element {
  const [email, setEmail] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [error, setError] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const normalizedEmail = email.trim().toLowerCase();

    if (!normalizedEmail) {
      setError('Please enter your email.');
      return;
    }

    if (!agreed) {
      setError('Please agree to continue.');
      return;
    }

    setError('');
    sendNewsletterSignup(normalizedEmail).catch((err) => {
      console.error('Failed to log newsletter signup:', err);
    });

    const subscribers = JSON.parse(localStorage.getItem('newsletterSubscribers') || '[]');
    if (!subscribers.includes(normalizedEmail)) {
      subscribers.push(normalizedEmail);
      localStorage.setItem('newsletterSubscribers', JSON.stringify(subscribers));
    }

    setSubscribed(true);
  };

  if (subscribed) {
    return (
      <div className="Donate1Newsletter Donate1Newsletter-Success">
        <h2>Thank you for supporting pangolins! &lt;3</h2>
        <span className="Donate1Newsletter-Envelope" role="img" aria-label="Envelope">💌</span>
        <p>Stay connected and follow the impact we are creating together!</p>
      </div>
    );
  }

  return (
    <div className="Donate1Newsletter">
      <h2>BE PART OF THE IMPACT!</h2>
      <p className="Donate1Newsletter-Subtext">
        Stay updated on our conservation work.
      </p>
      <span className="Donate1Newsletter-Envelope" role="img" aria-label="Envelope">💌</span>
      <form onSubmit={handleSubmit}>
        <div className="Donate1Newsletter-InputWrapper">
          <span className="Donate1Newsletter-InputIcon" aria-hidden="true">✉️</span>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <label className="Donate1Newsletter-Checkbox">
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
          />
          <span>By clicking &quot;Subscribe&quot;, you are submitting your information to pangolino</span>
        </label>
        {error && <p className="Donate1Newsletter-Error">{error}</p>}
        <button type="submit">Subscribe</button>
      </form>
    </div>
  );
}
